import { Base } from '../base-component';

import './image-carousel-item.component.scss';
import SliderComponent from '../slider/slider.component';
import { MediaQueryService } from '../../services/media-query.service';

export class ImageCarouselItem extends Base {

	constructor(element){
		super(element)
	}

	init(){};

	bindEvents(){};

}



// WEBPACK FOOTER //
// ./components/image-carousel-item/image-carousel-item.component.ts